<div class="terms-dialog">
  <header class="terms-header">
    <h2>
      {{ siteConfig.legal.terms.title.prefix }}
      <span>{{ siteConfig.legal.terms.title.highlight }}</span>
    </h2>

    <button
      mat-icon-button
      type="button"
      (click)="close()"
      aria-label="Cerrar"
      class="close-button"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <section class="terms-content">
    <div [innerHTML]="siteConfig.legal.terms.content"></div>
  </section>
</div>
